import { MutationHookOptions, useMutation } from '@apollo/client'
import {
  UpdateTagDocument,
  UpdateTagMutation,
  UpdateTagMutationVariables,
} from 'generated/resources/graphql'

import type { Tag } from 'modules/ats/hooks/tags/useTags'

type Options = MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>

// TODO: resource registry should expose this as a input type
interface UpdateTagInput {
  name: string
}

export const useUpdateTag = (tag: Tag, options: Options) => {
  const [updateTag, { loading }] = useMutation(UpdateTagDocument, options)

  return {
    loading,
    update({ name }: UpdateTagInput) {
      return updateTag({
        variables: { id: tag.id, name },
      })
    },
  }
}
